<template>
 <PlatformCategoryDropdown
    :platform="platform"
    :categories="categories"
    :is-active="isActive"
    :all-selected="allSelected"
    :selected-category-ids="selectedCategoryIds"
    @toggle-platform="$emit('toggle-platform')"
    @toggle-all="$emit('toggle-all-categories')"
    @toggle-category="$emit('toggle-category', $event)"
  >
    <template v-if="hasLifecycle" #append>
      <q-separator />
      <LifecycleStatusFilter
        :model-value="selectedLifecycleStatuses"
        @update:model-value="$emit('lifecycle-change', $event)"
      />
    </template>
  </PlatformCategoryDropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialSite, PostCategory, LifecycleStatus } from '@/type';
import PlatformCategoryDropdown from './PlatformCategoryDropdown.vue';
import LifecycleStatusFilter from './LifecycleStatusFilter.vue';

const LIFECYCLE_PLATFORMS = ['Facebook', 'Instagram'];

export default defineComponent({
  emits: ['lifecycle-change', 'toggle-all-categories', 'toggle-category', 'toggle-platform'],
  components: { PlatformCategoryDropdown, LifecycleStatusFilter },
  props: {
    platform: {
      type: Object as () => SocialSite,
      required: true,
    },
    categories: {
      type: Array as () => PostCategory[],
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    allSelected: {
      type: Boolean,
      required: true,
    },
    selectedCategoryIds: {
      type: Array as () => number[],
      required: true,
    },
    selectedLifecycleStatuses: {
      type: Array as () => LifecycleStatus[] | null,
      default: null,
    },
  },
  computed: {
    hasLifecycle(): boolean {
      return LIFECYCLE_PLATFORMS.includes(this.platform.type);
    },
  },
});
</script>
